import validate from "/src/node_modules/.pnpm/nuxt@3.19.0_@parcel+watcher@2.5.1_@types+node@24.5.2_@vue+compiler-sfc@3.5.21_db0@0.3.2_837f92277022ac0a5f33d8e3a9f1bd26/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/src/node_modules/.pnpm/nuxt@3.19.0_@parcel+watcher@2.5.1_@types+node@24.5.2_@vue+compiler-sfc@3.5.21_db0@0.3.2_837f92277022ac0a5f33d8e3a9f1bd26/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}